"use client";

import { useEffect } from "react";
import { useParams, useRouter } from "next/navigation";

export default function LocaleNotFound() {
  const router = useRouter();
  const params = useParams();
  const locale = (params?.locale as string) || "vi";

  useEffect(() => {
    router.replace(`/${locale}`);
  }, [router, locale]);

  return null;
}
